(function( $ ) {
		$( document ).ready( function() {
			'use strict';

			$( '#your-subscriptions input[type=checkbox]' )
				.click( updateBtnState );

			$(document).on('click', '#your-subscriptions input[type=checkbox]', preferencesUpdatedMsg);
			
			$( '#committee-status-table input[type=checkbox]' )
				.click( updateBtnStateCommittee );

			$( '#account-change-email-prefs input[type=checkbox]' )
				.click( preferencesUpdatedMsg );

			$( '#account-change-email-prefs-logged-out input[type=checkbox]' )
				.click( preferencesUpdatedMsg );

		} );//doc ready

		$( document )
			.on( 'click', '.btn-invoice-btn , .btn-invoice-btn-no-balance', printInvoice );

		/**
		 * Reveal Preferences Updated Alert
		 */
		function preferencesUpdatedMsg() {
			
			$( '.newsletter-sub-msg' ).hide();//remove url param message to prevent confusion w/ ajax messages
			let isChecked = $( this ).is( ':checked' );
			let message = '', messageText = '',
			    messageClasses            = '',
			    emailPrefsTab             = $( '#account-change-email-prefs' ),
			    emailPrefsTabLoggedOut    = $( '#account-change-email-prefs-logged-out' );

			const email = $( '#nl-email' ).val(), $this = $( this ),
			      sub                                   = $this.attr( 'name' ).match( /\[(.*?)\]/ )[ 1 ],
			      label                                 = $this.parent( 'label' ).text();
			const url = `${wpApiSettings.root}isda/v1/newsletters`;

			$.post( url, { email, sub } ).success( function( response ) {
				messageText = response.status
					? 'Your preferences have been successfully updated for ' + label + '.'
					: 'There was a problem updating your preferences. Please contact isda@isda.org for help.';
				messageClasses = response.status
					? 'alert alert-success'
					: 'alert alert-danger';
				message = '<div class="' + messageClasses + '" role="alert">' + messageText + '</div>';

				emailPrefsTab.prepend( message ).find( '.alert' ).delay( 3000 )
				             .fadeOut( 500, function() {
					             $( this ).remove();
				             } );

				emailPrefsTabLoggedOut.append( message ).find( '.alert' )
				                      .delay( 3000 ).fadeOut( 500, function() {
					$( this ).remove();
				} );

				if ( sub === 'UNSUBSCRIBE' && isChecked ) {
					clearNonSubscribeCheckboxes( $this );
				}

				if ( sub !== 'UNSUBSCRIBE' ) {
					clearUnsubscribe();
				}
			} );
		}

		function updateBtnState( checkbox ) {
			var preferencesCheckbox = checkbox.target;

			if ( preferencesCheckbox.checked ) {
				//checked classes
				addCheckedState( preferencesCheckbox );
			} else {
				//unchecked classes
				removeCheckedState( preferencesCheckbox );
			}
		}

		/**
		 * Update button status
		 */
		function updateBtnStateCommittee() {
			let mainBox = $( this );

			let secondaryBox = $( '#no-opt-out-committee' );
			let option = true;
			if ( mainBox.attr( 'id' ) !== 'opt-out-committee' ) {
				secondaryBox = $( '#opt-out-committee' );
				option = false;
			}
			addCheckedState( mainBox );
			removeCheckedState( secondaryBox );
			updateCommitteeColleagueStatus( option );
		}

		/*
		 Upating the committee colleague status
		 */
		function updateCommitteeColleagueStatus( preference ) {
			const url = `${wpApiSettings.root}isda/v1/committees/preferences`;
			const partyID = $( '#committee-status-table' )
				.attr( 'data-party-id' );
			$.post( url, { partyID, preference } )
			 .success( function( response ) {
				 console.log( response );
			 } );
		}

		/** 
		 * Clear unsubscribe if another checkbox is checked
		 */
		function clearUnsubscribe() {
			let unsubscribeCheckbox =  $( 'input:checkbox[name="nls[UNSUBSCRIBE]"]' );
			if ( unsubscribeCheckbox.is( ':checked' ) ) {
				unsubscribeCheckbox.prop('checked', false);
			}
		}

		/**
		 * Clear all other buttons if unsubscribe is checked
		 * @param checkbox
		 */
		function clearNonSubscribeCheckboxes() {
		    // Select all input fields that have a parent with the class "newsletter"
		    var allCheckboxes = document.querySelectorAll('.newsletter input[type=checkbox]');

		    // Iterate over all checkboxes
		    for (var i = 0; i < allCheckboxes.length; ++i) {
		        // If the checkbox's name is not "nls[UNSUBSCRIBE]", uncheck it
		        if (allCheckboxes[i].name !== 'nls[UNSUBSCRIBE]') {
		            allCheckboxes[i].checked = false;
		        }
		    }
		}

		/**
		 * Add classes for checked state & trigger state changes
		 * @param checkbox
		 */
		function addCheckedState( checkbox ) {
//			checkbox.parentElement.classList.add( 'is-checked' );
//			checkbox.previousElementSibling.classList.add( 'glyphicon' );
//			checkbox.previousElementSibling.classList.add( 'glyphicon-ok' );
//
//			if ( checkbox.getAttribute( 'name' ) === 'nls[UNSUBSCRIBE]' ) {
//				//if subscribe, uncheck all others
//				clearNonSubscribeCheckboxes( checkbox );
//			}
//
//			if ( checkbox.getAttribute( 'name' ) !== 'nls[UNSUBSCRIBE]' ) {
//				//else if other, uncheck unsubscribe
//				clearUnsubscribe();
//			}
		}

		/**
		 * Remove classes for checked state
		 * @param checkbox
		 */
		function removeCheckedState( checkbox ) {
//			checkbox.parentElement.classList.remove( 'is-checked' );
//			checkbox.previousElementSibling.classList.remove( 'glyphicon' );
//			checkbox.previousElementSibling.classList.remove( 'glyphicon-ok' );
		}

		function printInvoice() {
			event.preventDefault();
			setTimeout( function() {
				w.print();
			}, 100 );

			let w = window.open( $( this ).attr( 'href' ) );

			w.onafterprint = function() {
				w.close();
			};
		}
	}
)( jQuery );